<template>
  <div>
    <CCard style="margin-top: 20px">
      <CCol xs="12" lg="12" style="margin-top: 20px">
        <CTabs variant="pills">
          <CTab title="Esports Game">
            <AddGame></AddGame>
          </CTab>
          <CTab title="Esports Tournament List">
            <hr />
            <EsportsTournamentList1Vue></EsportsTournamentList1Vue>
          </CTab>
          <!-- <CTab title="Esports Distribution">
            <hr />
            <EsportsDistributionVue></EsportsDistributionVue>
          </CTab> -->
          <!-- <CTab title="Esports Game Entry">
            <hr />
            <EsportsPointTable></EsportsPointTable>
          </CTab> -->
        </CTabs>
      </CCol>
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import EsportsPointTable from "./esportsPointTable.vue";
import EsportsDistributionVue from "./esportsDistribution.vue";
import AddGame from "./addgame.vue";
import EsportsTournamentList1Vue from "./esportsTournamentList1.vue";
export default {
  components: {
    EsportsPointTable,
    AddGame,
    EsportsTournamentList1Vue,
    EsportsDistributionVue,
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
    };
  },
  watch: {},
  methods: {
    // sendmsg(){}
  },
  created() {},
};
</script>
<style>
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>
